import { render, staticRenderFns } from "./InWayInvetoryOrders.vue?vue&type=template&id=d468fa32&"
import script from "./InWayInvetoryOrders.vue?vue&type=script&lang=js&"
export * from "./InWayInvetoryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports